import React from 'react'
import { useTheme } from '../../context/ThemeProvider'
import { AiOutlineSun, AiFillMoon } from 'react-icons/ai'
import {
  getThemeMode,
  getThemeName,
  composeTheme,
} from '../../utils/theme-utils'
import { ThemeMode } from '../../constants/theme'

const ThemeToggle: React.FC = () => {
  const { theme, setTheme } = useTheme()

  const currentMode = getThemeMode(theme)
  const currentName = getThemeName(theme)
  const isLightMode = currentMode === ThemeMode.LIGHT

  const toggleTheme = () => {
    const newMode = isLightMode ? ThemeMode.DARK : ThemeMode.LIGHT
    const newTheme = composeTheme(currentName, newMode)
    setTheme(newTheme)
  }

  return (
    <button
      type="button"
      onClick={toggleTheme}
      className="relative flex items-center h-8 sm:h-10 w-16 sm:w-20 rounded-full cursor-pointer bg-[var(--lang-bg)] hover:bg-[var(--bet-type-hover-bg)] border border-transparent transition-colors duration-200"
      title={`Switch to ${isLightMode ? 'Dark' : 'Light'} Mode`}
    >
      {/* Sun Icon - Left side (inactive when dark mode) */}
      {!isLightMode && (
        <div className="absolute left-0.5 sm:left-1 flex items-center justify-center w-7 h-7 sm:w-8 sm:h-8">
          <AiOutlineSun className="text-sm sm:text-base text-[var(--theme-toggle-sun-inactive-color)] transition-colors duration-200" />
        </div>
      )}

      {/* Moon Icon - Right side (inactive when light mode) */}
      {isLightMode && (
        <div className="absolute right-0.5 sm:right-1 flex items-center justify-center w-7 h-7 sm:w-8 sm:h-8">
          <AiFillMoon className="text-sm sm:text-base text-[var(--theme-toggle-moon-inactive-color)] transition-colors duration-200" />
        </div>
      )}

      {/* Sliding Circle Indicator with Active Icon */}
      <div
        className={`absolute w-7 h-7 sm:w-8 sm:h-8 active-gradient rounded-full shadow-sm transition-transform duration-200 ease-in-out flex items-center justify-center ${
          isLightMode
            ? 'transform translate-x-0.5 sm:translate-x-1'
            : 'transform translate-x-8 sm:translate-x-11'
        }`}
      >
        {/* Active Icon inside the circle */}
        {isLightMode ? (
          <AiOutlineSun className="text-sm sm:text-base text-black" />
        ) : (
          <AiFillMoon className="text-sm sm:text-base text-black" />
        )}
      </div>
    </button>
  )
}

export default ThemeToggle
